<template>
  <div class="flex justify-center bg-gray-900 pt-1">
    <add-transform-variable v-if='adding'
                            :source='selectedVariableSource'
                            @close='adding = false'
                            />
    <edit-transform-variable v-if='editingVariable' v-model='editingVariable' @close='editingVariable = null' />
      <div class="flex-none w-8">
        <ul class="ml-1 flex-row font-hairline text-xs justify-center">
          <li>
          <button :class='makeToggleClasses(type.type)' v-for='type in types' :key='type.type' @click='toggle(type)'>
            <component :is='type.icon' :size='16'/>
            {{type.name}}
          </button>
          </li>
        </ul>
      </div>
    <div class="flex-grow h-full flex-row">

      <!--
      <div class="w-full bg-gray-700 flex py-3">
        <div :class="makeToggleClasses(type.type)" v-for='type in types' :key='type.type' @click='toggle(type)'>
          <component :is='type.icon' />
        </div>
      </div>
      -->
      <div class="flex justify-center">
        <input id="searchfield" type="search" placeholder="Search..." v-model='searchText' autofocus="autofocus" class="w-full text-grey-800 transition focus:outline-none focus:border-transparent p-2 appearance-none leading-normal text-md lg:text-lg">
      </div>
      <div class="h-full flex flex-shrink flex-wrap bg-gray-600 overflow-y-auto">
        <div v-for='variable in filteredVariables' :key='variable.variable.name'>
          <pbc-button @click='editingVariable = variable.variable' v-if='toggled(variable)' :class="variableClass(variable)" >
          {{variable.variable.name}}
          </pbc-button>
        </div>
      </div>
        <div class="mx-0 ">
          <button @click='onAddLocal' class="pbc-standard-button align-middle">
            <plus-circle />Local
          </button>
          <button @click='onAddScene' class="pbc-standard-button align-middle">
            <plus-circle />Scene
          </button>
          <button @click='onAddGlobal' class="pbc-standard-button align-middle">
            <plus-circle />Global
          </button>
        </div>
    </div>
  </div>
</template>
<script>
import { debounce, sortBy } from 'lodash';
import AddTransformVariable from '@ui/molecules/AddTransformVariable.vue';
import EditTransformVariable from '@ui/molecules/EditTransformVariable.vue';
import Numeric1BoxMultiple from '@icons/Numeric1BoxMultiple.vue';
import Numeric2BoxMultiple from '@icons/Numeric2BoxMultiple.vue';
import Numeric3BoxMultiple from '@icons/Numeric3BoxMultiple.vue';
import Numeric4BoxMultiple from '@icons/Numeric4BoxMultiple.vue';
import PlusCircle from '@icons/PlusCircle.vue';

export default {
  props:{
    value:{
      type:Array,
      required:true
    },
    variablesSource:{
      type:Array,
      required:true
    },
    transformsAndSource:{
      type:Object,
      required:true
    }
  },
  components:{
    PlusCircle,
    AddTransformVariable,
    EditTransformVariable
  },
  mounted() {
    this.doSearch = debounce(this._doSearch, 200);
  },
  data() {
    const variables = this.groupVariables();
    const colors = {
      "ancestor":"border-blue-700",
      "transform":"border-blue-600",
      "gamedata":"border-blue-900",
      "scene":"border-blue-800"
    }

    return {
      variables,
      editingVariable:null,
      filteredVariables:variables,
      colors,
      toggles:{
        transform:true,
        ancestor:true,
        scene:true,
        gamedata:true
      },
      types:[
        {type:'transform',name:'Local',icon:Numeric1BoxMultiple},
        {type:'ancestor',name:'Ancestor',icon:Numeric2BoxMultiple},
        {type:'scene',name:'Scene',icon:Numeric3BoxMultiple},
        //{type:'toy'},
        {type:'gamedata',name:'Global',icon:Numeric4BoxMultiple},
      ],
      searchText:'',
      adding:false,
      selectedVariableSource:this.variablesSource
    }
  },
  methods:{
    onAddLocal() {
      this.adding = !this.adding;
      this.selectedVariableSource = this.variablesSource;
    },
    onAddScene() {
      this.adding = !this.adding;
      this.selectedVariableSource = this.transformsAndSource.from.variables || [];
    },
    onAddGlobal() {
      this.adding = !this.adding;
      this.selectedVariableSource = this.gamedata.variables;
    },
    groupVariables() {
      return sortBy(this.value.map( ({origin,variable}) => {
        const order = {
          "ancestor":1,
          "transform":0,
          "gamedata":3,
          "scene":2
        }[origin.source]
        return {origin,variable,order};
      }), "order");
    },
    _doSearch() {
      this.filteredVariables = this.variables.filter( ({variable}) => {
        return this.searchText.trim() === '' || variable.name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1;
      });
    },
    toggled({origin,variable}) {
      return this.toggles[origin.source];
    },
    toggle({type,name}) {
      this.toggles[type] = !this.toggles[type];
    },
    variableClass(variable) {
      console.log('ORIGIN', variable.origin.source);
      const classes = "h-8 flex-grow-0 text-sm mx-2 my-1 px-2 py-1 rounded-lg text-white shadow-lg".split(" ");
      //classes.push(this.colors[variable.origin.source]);
      return classes;
    },
    makeToggleClasses(type) {
      //const classes = "cursor-pointer mx-2 my-1 px-2 py-1 rounded-lg shadow-lg shadow-outline".split(" ");
      const classes = "inline-block border-gray-600 border-l border-t border-b rounded-l py-1 px-1 mb-1 font-semibold".split(" ");

      if (this.toggles[type]) {
        classes.push(this.colors[type]);
        classes.push("bg-gray-600");
        classes.push("text-white");
      } else {
        classes.push("bg-gray-500");
        classes.push("text-white");
      }
      return classes;
    }
  },
  watch:{
    searchText() {
      this.doSearch();
    },
    toggles:{
      deep:true,
      handler() {
        this.doSearch();
      }
    },
    value() {
      console.log('lulzes');
      this.variables = this.groupVariables();
      this.doSearch();
    }
  },
  computed:{
    gamedata() {
      return this.transformsAndSource.gamedata.gamedata;
    }
  }
}
</script>

